<style scoped>
@import url("../assets/css/read.css");
</style>

<template>
  <div class="read-content">
    <van-nav-bar @click-left="pageBack" :title="name" fixed :z-index="1000" class="menu-title-box">
      <img slot="left" src="../assets/image/icon_v2/return_white@2x.png" class="return_icon" />
    </van-nav-bar>
    <div class="book-img">
      <img :ref="img.url" v-lazy="img.url" v-for="(img,index) in images" :key="index" alt="图片"/>
      <!-- <img :src="img.url" v-for="(img,index) in images" :key="index" alt="图片"/> -->
    </div>
    <div class="tip-box">
        <p class="font-c-3">本文共<span class="theme-c">{{total_count}}</span>页，可试读<span class="theme-c">{{try_count}}</span>页</p>
        <p class="font-c-6">试读已结束，如需获得全文请点击<span class="theme-c">帮助</span></p>
        <button class="book-btn" @click="customer">
          帮助
        </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      volumeId: null,
      bookId:null,
      images: {},
      name:null,
      cover: null,
      total_count: null,
      try_count: null,
      book_info:null
    };
  },
  methods: {
    getImages(volumeId) {
      var that = this;
      this.$api.get("/book/read_m/" + that.volumeId).then(function(res) {
        that.name = res.data.data.book_info.name;
        that.cover = res.data.data.book_info.cover;
        that.total_count = res.data.data.book_info.total_count;
        that.try_count = res.data.data.book_info.try_count;
        that.images = res.data.data.images;
        that.shareConfig();
      });
    },
    pageBack() {
      this.$router.push({path:'/info/'+this.bookId})
    },
    customer() {
      _MEIQIA('showPanel');
    },
    shareConfig() {
      let url = window.location.href.split('#')[0]
      let obj = {
        title: '您的好友邀您一起欣赏《'+this.name+'》',
        desc: '我能想到最好的礼物就是把好书推荐给你。',
        link: url,
        imgUrl:this.cover
      }
      this.$wxApi.getJSSDK(url,obj)
    }
  },
  created() {
    this.volumeId = this.$route.query.vid;
    this.bookId = this.$route.query.bid;
    // this.volumeId = this.$route.params.volume_id;
    // this.bookId = this.$route.params.book_id;
    this.getImages(this.volumeId);

    const hashLocation = this.$route.path
		const url = "https://m.kanguji.com"+hashLocation
		this.$matomo.setCustomUrl(url);
  }
};
</script>


// WEBPACK FOOTER //
// src/components/read.vue